import React from 'react';

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { find } from 'lodash';
import { connect } from 'react-redux';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import COLResults from './col-results';
import type { COLResultsProps } from './col-results';

const parseCompareCOLVariables = (citiesSlug, cities) => {
  const [sourceSlug, destinationSlug] = (citiesSlug || '').split('-vs-');
  const sourceCityData = find(cities, { slug: sourceSlug });
  const destinationCityData = find(cities, { slug: destinationSlug });
  const sourceCityState = `${sourceCityData?.name}, ${sourceCityData?.state_abbr}`;
  const destinationCityState = `${destinationCityData?.name}, ${destinationCityData?.state_abbr}`;
  return {
    sourceCityState,
    destinationCityState,
    citiesSlug,
  };
};

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/cost-of-living-calculator/compare/CITIES`,
  metadataOptions: (props) => {
    const citiesSlug = props?.params?.citiesSlug;
    const variables = parseCompareCOLVariables(citiesSlug, props?.cities);
    return {
      variables,
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('col') },
      url: (url) =>
        url ? url.replace('CITIES', props?.params?.citiesSlug) : url,
    };
  },
};

const COLCompareResultsWrapper = (props: COLResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={COLResults}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    cities: state?.costOfLivingCalculator?.cities,
  };
};

export default connect(mapStateToProps)(COLCompareResultsWrapper);
